import OldReportMediator from './OldReportMediator'
import {ReportType} from './constants'
import ReportPrintableHeadersBuilder from './ReportPrintableHeadersBuilder'
import _ from 'underscore'
import TTDetailReportEditResultConfigController from './edit_config_controller/ttDetail/TTDetailReportEditResultConfigController'

export default function TTDetailReportMediator ()
{
    this.constructor = TTDetailReportMediator;
}

TTDetailReportMediator.prototype = _.create(OldReportMediator.prototype);

TTDetailReportMediator.prototype.init = function ( config )
{
    OldReportMediator.prototype.init.call(this, config);

    return this;
};

TTDetailReportMediator.prototype.getReportType = function()
{
    return ReportType.TIME_TRACK_IN_DETAIL;
};

TTDetailReportMediator.prototype.initEditConfigController = function( config )
{
    const self = this;
    return new TTDetailReportEditResultConfigController().init(
            {
                reportAuthorizationInfo: config.reportAuthorizationInfo,
                reportParameters: config.reportParameters,
                cpList: config.cpList,
                customersWithMaIds: config.customersWithMaIds,
                projectsWithMaIds: config.projectsWithMaIds,
                users: config.users,
                manageableUsersIds: config.manageableUserIds,
                userGroups: config.userGroups,
                timeZoneGroups: config.timeZoneGroups,
                changeCallback: function(){ self.changeParametersCallback(); }
            } );
};

TTDetailReportMediator.prototype.initPrintableHeadersBuilder = function( config ) {
    return new ReportPrintableHeadersBuilder().init(
            {
                reportParameters: config.reportParameters,
                cpList: config.cpList,
                users: config.users,
                userGroups: config.userGroups,
                timeZoneGroups: config.timeZoneGroups,
                isFilteredByAssignments: config.isFilteredByAssignments,
            }
    );
};

TTDetailReportMediator.prototype._populateHeadersArray = function( headersArray ) {
    this.printableHeadersBuilder.addCPSelectionParamsStringToArray( this.reportParameters.customersProjectsSelection, headersArray ); //customers and projects
    this.printableHeadersBuilder.addStaffSelectionParamsToArray( this.reportParameters.userSelection, headersArray ); //staff
    this.printableHeadersBuilder.addTimeApprovalStatusToArray( this.reportParameters.timeApprovalStatus, headersArray ); //time approval status
};


// WEBPACK FOOTER //
// ./web/js/reports/TTDetailReportMediator.js